<template>
  <div class="bg-gray-50 py-6 pb-24 space-y-6" dir="rtl">
    <div class="max-w-2xl mx-auto px-4 space-y-6">
    
    <!-- Leave Type Select -->
    <div class="bg-white rounded-xl p-5 border border-gray-200">
      <label class="block text-sm font-bold text-gray-700 mb-3">نوع مرخصی</label>
      <div class="relative">
        <select 
          v-model="selected_morakhasi_type"
          class="morakhasi-form-field morakhasi-form-select"
        >
          <option :value="0">انتخاب کنید</option>
          <option :value="1">ساعتی</option>
          <option :value="2">استحقاقی</option>
          <option :value="3">استعلاجی</option>
          <option :value="4">بدون حقوق</option>
        </select>
        <div class="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
          <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
          </svg>
        </div>
      </div>
    </div>

    <!-- Date Range -->
    <div class="bg-white rounded-xl p-5 border border-gray-200">
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-bold text-gray-700 mb-3">از تاریخ</label>
          <date-picker v-model="start_date" />
        </div>
        <div>
          <label class="block text-sm font-bold text-gray-700 mb-3">تا تاریخ</label>
          <date-picker v-model="end_date" />
        </div>
      </div>
    </div>

    <!-- Time Range (for hourly leave) -->
    <div v-if="selected_morakhasi_type==1" class="bg-white rounded-xl p-5 border border-gray-200">
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-bold text-gray-700 mb-3">از ساعت</label>
          <date-picker 
            type="time"
            v-model="start_time"
          />
        </div>
        <div>
          <label class="block text-sm font-bold text-gray-700 mb-3">تا ساعت</label>
          <date-picker 
            type="time"
            v-model="end_time"
          />
        </div>
      </div>
    </div>

    <!-- Successor User -->
    <div class="bg-white rounded-xl p-5 border border-gray-200">
      <label class="block text-sm font-bold text-gray-700 mb-3">کاربر جانشین</label>
      <treeselect
        :multiple="false"
        :load-options="load_users"
        :normalizer="normalizer_persons"
        :async="true"
        append-to-body
        placeholder="کاربر جانشین"
        v-model="janeshin_user"
      />
    </div>

    <!-- Description -->
    <div class="bg-white rounded-xl p-5 border border-gray-200">
      <label class="block text-sm font-bold text-gray-700 mb-3">توضیحات</label>
      <textarea
        v-model="morakhasi_summary"
        rows="3"
        class="morakhasi-form-field morakhasi-form-textarea"
        placeholder="توضیحات مرخصی را وارد کنید..."
      ></textarea>
    </div>

    <!-- Add File Section -->
    <div class="bg-white rounded-xl p-5 border border-gray-200">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-base font-bold text-gray-900 w-full">{{ $t('add_file') }}</h3>
        <button 
          v-if="files.length==0"
          @click="select_file()"
          class="w-10 h-10 bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 rounded-lg flex items-center justify-center transition-all duration-200"
        >
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
        </button>
      </div>
      
      <input id="fileUpload" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.gif" type="file" hidden v-on:change="input_file_changed">
      
      <!-- Files Display -->
      <div v-if="files.length > 0" class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3">
        <div 
          v-for="(item, i) in files"
          :key="i"
          class="relative"
        >
          <button 
            @click="delete_file(i)"
            class="absolute -top-2 -right-2 w-6 h-6 bg-red-600 rounded-full flex items-center justify-center z-10 transition-transform hover:scale-110"
          >
            <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <img 
            loading="lazy" 
            :src="item.file" 
            class="w-full h-24 object-cover rounded-lg border border-gray-200"
          />
        </div>
      </div>
    </div>

    <!-- Submit Button -->
    <button 
      @click="save()"
      class="w-full bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white py-4 px-6 rounded-xl font-bold transition-all duration-200 flex items-center justify-center gap-2"
    >
      ثبت درخواست مرخصی
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </button>

    <infinite-loading @infinite="infiniteHandler" v-if="show_loading">
      <div slot="no-more">{{ $t('no_records') }}</div>
    </infinite-loading>

    </div>
  </div>
</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import {bus} from '../../main'
  import { longClickDirective } from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";
  import moment from 'moment-jalaali'


  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        date_type:'datetime',
        morakhasi_summary:'',
        janeshin_user:null,
        morakhasi_types:[],
        selected_morakhasi_type:0,
        start_date:'',
        end_date:'',
        start_time:'',
        end_time:'',
        files: [],
        product_info_dialog:false,
        selected_product_info:{},
        list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click:false,
        category_items: [],
        request_statuses: [],

        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,

      }
    },
    components: {
      InfiniteLoading,
      Treeselect
    },
    watch: {

    },
    mounted() {
      this.start_date = moment().utc().format('jYYYY/jMM/jDD');
      this.end_date = moment().utc().format('jYYYY/jMM/jDD');

      // this.get_pre_requests()
      // this.get_device_status();
    },

    methods: {
      load_users ({ action, searchQuery, callback }) {
        this.model_txt = searchQuery
        var self = this
        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options
            this.isLoading = true
            var user_id = JSON.parse(localStorage.getItem('profile')).UserId

            var self = this
            const send_data = {
              Txt: searchQuery,
              UserId: user_id,
            }
            this.axios.post('/GetUsersByTxt', send_data, {})
              .then(response => {
                // self.search_entries = response.data.Payks
                options = response.data.Payks
                callback(null, options)
                // this.$router.push({ path: "/post-login", params: {} });
              }).catch(e => {
              this.errors.push(e)
            })
          })
        }
      },

      get_device_status () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetStatusSetting', send_data, {})
          .then(response => {
            self.request_statuses = response.data.rslt
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_pre_requests($state) {
        // this.request_items = [];
        this.request_items = JSON.parse(localStorage.getItem('buy_orders_finalize'))
      },
      infiniteHandler($state) {
        var self = this
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
          self.page += 1
          self.get_pre_requests($state)
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000)
      },
      save() {
        if (this.files.length==0) {
          bus.$emit('show_toast', [1500, this.$t('please_select_image')])
        return false;
        }
        if (this.selected_morakhasi_type==0) {
          bus.$emit('show_toast', [1500, 'نوع مرخصی را انتخاب کنید'])
        return false;
        }
        this.upload_image(0);
      },
      select_file() {
        // if (index == 0) {
        // this.open_camera();
        // this.dialog_camera = true;
        // document.getElementById('fileUpload').click()
        // }
        // if (index == 1) {
        document.getElementById('fileUpload').click()
        // }
      },
      delete_file(index) {
        this.files.splice(index, 1)
      },
      input_file_changed() {
        console.log("input_file_changed")
        var self = this

        var reader = new FileReader()
        var f = document.getElementById('fileUpload').files
        // if (f != null) {
        reader.onloadend = function () {
          // console.log(reader.result);
          if (!reader.result.startsWith('data:image/webp')) {
            self.resizeBase64Img(reader.result, 700, 700).then(function (newImg) {
              // $("body").append(newImg[0]);
              // console.log("resized",newImg[0].src)
              var obj = {file: newImg[0].src, preview: reader.result, upload: 0}
              self.files.push(obj)
              reader = null;
              f = null;
              document.getElementById('fileUpload').files = null;
              obj = null;
            })
            // console.log(obj)
          } else {
            bus.$emit('show_toast', [1500, self.$t('fileIsNotGranted')])
          }
        };
        reader.readAsDataURL(f[0])

        // }

      },

      async resizeBase64Img(base64, minimum) {
        try {

          var canvas = document.createElement('canvas')

          var deferred = $.Deferred()
          $('<img/>').attr('src', base64).load(function () {
            var last_width = this.width
            var last_height = this.height

            if (last_width > last_height) {
              last_width = (last_width * minimum) / last_height
              last_height = minimum
            } else {
              last_height = (last_height * minimum) / last_width
              last_width = minimum
            }
            canvas.width = last_width
            canvas.height = last_height
            var context = canvas.getContext('2d')

            console.log(this.width, this.height)
            context.scale(last_width / this.width, last_height / this.height)
            context.drawImage(this, 0, 0)

            deferred.resolve($('<img/>').attr('src', canvas.toDataURL()))
          })
          return deferred.promise()
        } catch (e) {
          bus.$emit('show_toast', [3000, "error on Base64Img"])

        }
      },
      upload_image(index) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var form_data = new FormData()
        form_data.append('UserId', user_id)
        form_data.append('Format', 'png')
        form_data.append('ReqType', 11)
        form_data.append('DocType', 1)
        var my_file = this.files[index].file

        var file = this.dataURLtoFile(my_file, 'attach.png')
        form_data.append('Picture', file)

        this.axios.post('UploadFile', form_data, {})
          .then(response => {
            // self.send_signature(response.data.ArchiveId,response.data.ImageName);
            if (response.data.error == 0) {
              self.files[index].upload = 1
              self.files[index].ArchiveId = response.data.ArchiveId
              self.files[index].ImageName = response.data.ImageName
              // if (index < self.files.length - 1) {
              //   self.upload_image(index + 1)
              // } else {
                self.send_attach()
              // }

              // var finish_all = true;
              //   self.files.forEach(function (number) {
              //     if (number.upload != 1) {
              //       finish_all = false;
              //     }
              //   });
              // if (finish_all) {
              //   self.files[0].upload = 1;
              //
              // }
            } else {
              self.files[index].upload = 2
              bus.$emit('show_toast', [1500, response.data.msg])
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      dataURLtoFile(dataurl, filename) {
        try {

          var arr = dataurl.split(',')
          var mime = arr[0].match(/:(.*?);/)[1]
          var bstr = atob(arr[1])
          var n = bstr.length
          var u8arr = new Uint8Array(n)

          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }

          return new File([u8arr], filename, {type: mime})
        } catch (e) {
          bus.$emit('show_toast', [3000, "error on dataURLtoFile"])

        }
      },

      send_attach() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        // console.log();

        var attachment_array = []

        // self.request_items.forEach(function (number) {
        //
        //   var pre_obj = {
        //     StatusId: self.request_statuses[12],
        //     ImageName: self.files[0].ImageName,
        //     Summary: '',
        //     FileTypeId: 1,
        //     GRequestProductId: number.GoodsRequestProductId,
        //   }
        //   attachment_array.push(pre_obj)
        // })

        // start_time
        // end_time
        const send_data = {
          LeaveType: self.selected_morakhasi_type,
          FromDate:self.start_date+" "+self.start_time+":00" ,
          ToDate: self.end_date+" "+self.end_time+":00" ,
          SuccessorId: self.janeshin_user,
          Desc: self.morakhasi_summary,
          ArchiveId:self.files[0].ArchiveId,
        ImageName:self.files[0].ImageName,
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/LeaveRegistration', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])

            if (response.data.error == 0) {
              self.$router.go(-1)
            }

          }).catch(e => {
          this.errors.push(e)
        })
      }

    }
  }
</script>
<style scoped>
.morakhasi-form-field {
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db !important;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 15px;
  color: #111827;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.morakhasi-form-field:focus {
  border-color: #4f46e5 !important;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
}

.morakhasi-form-select {
  min-height: 48px;
  font-weight: 500;
  appearance: none;
  cursor: pointer;
  padding-left: 40px;
}

.morakhasi-form-textarea {
  resize: none;
  min-height: 96px;
}
</style>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
